import React, { Component } from 'react';
import { Select, Input } from 'antd';
import {getYears} from "../../../../services/utils";
import {connect} from "react-redux";

const { Option } = Select;

class YearFilter extends Component {

  render() {

    const {year, handleYearChange, eventStatsFilter} = this.props;

    return (
      <Select
        style={{ width: 120 }}
        onChange={handleYearChange}
        value={year}
      >
        {getYears().filter(year => year != eventStatsFilter.year[0]).map((year) => (
          <Option key={year} value={year}>
            {year}
          </Option>
        ))}
      </Select>
    );
  }
}

const mapStateToProps = state => ({
  eventStatsFilter: state.filters.eventStatsFilter,
});


export default connect(mapStateToProps)(YearFilter);



// WEBPACK FOOTER //
// ./app/components/Filters/EventStats/CompareStats/YearFilter.js